'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessages = exports.fetchLocalesPromise = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.initLocalization = initLocalization;

var _scriptjs = require('scriptjs');

var _scriptjs2 = _interopRequireDefault(_scriptjs);

var _reactIntl = require('react-intl');

var _effects = require('redux-saga/effects');

var _cwUi = require('cw-ui');

var _CwLog = require('../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _IntlService = require('../services/IntlService');

var _ModuleReducer = require('../components/module/ModuleReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [fetchLocales, initLocalization].map(_regenerator2.default.mark);

var REACT_I18N_URL = "https://files.connectwise.com/i18n/";

/**
 * @typedef {object} LocaleData
 * @property {string} localeVersion
 * @property {string} reactIntlDefaultLocale
 * @property {string} locale
 * @property {string} localePrefix
 * @property {string} moduleId
 * @property {string} serverLocaleURL
 */

var messages = undefined;

/**
 * Returns list of scripts to be injected for react-intl localization
 * @param {LocaleData} localeData 
 * @returns {string[]}
 */
var getLocaleScripts = function getLocaleScripts(localeData) {
  var scripts = [];

  if (_cwUi.BrowserUserAgent.is_ie11() || _cwUi.BrowserUserAgent.is_edge() || _cwUi.BrowserUserAgent.is_safari() && !_cwUi.BrowserUserAgent.is_chrome()) {
    scripts.push(REACT_I18N_URL + 'intl/locale-data/jsonp/' + localeData.locale + '.js');
  }

  // download react-intl locale data
  scripts.push(REACT_I18N_URL + 'react-intl/locale-data/' + localeData.localePrefix + '.js');

  return scripts;
};

/**
 * Fetches module locale data
 * @param {string} moduleId 
 * @param {LocaleData} localeData 
 */
var fetchLocale = function fetchLocale(moduleId, localeData) {
  return fetch(localeData.serverLocaleURL + 'messages/' + moduleId + '/' + localeData.localeVersion + '/' + localeData.localePrefix + '.json', { method: 'GET' }).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  }).then(function (json) {
    return json[localeData.localePrefix] || json[localeData.locale];
  }).catch(function (e) {
    // if error trying to get locale data,
    // then just log to console and continue with default locale
    _CwLog2.default.error(e);
    return {};
  });
};

/**
 * Downloads locales for all modules (including Core and Common) and returns the merged translations to callback
 * @param {LocaleData} localeData 
 * @param {function(any)} callback
 */
function fetchLocales(localeData, callback) {
  var translations, modules, results;
  return _regenerator2.default.wrap(function fetchLocales$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          translations = undefined;

          // Do not download message locale json if locale matches the default locale

          if (!(localeData.locale !== localeData.reactIntlDefaultLocale)) {
            _context.next = 7;
            break;
          }

          // array of modules to download locales for
          // any new required module locales should be added to this array
          modules = ['Core', 'Common', localeData.moduleId];

          // download all module translations IN PARALLEL

          _context.next = 5;
          return (0, _effects.all)(modules.map(function (m) {
            return (0, _effects.call)(fetchLocale, m, localeData);
          }));

        case 5:
          results = _context.sent;


          // merge module translation results to one blob
          translations = results.reduce(function (acc, x) {
            return (0, _assign2.default)({}, acc, x);
          }, {});

        case 7:

          // initialize static formatMessage service
          (0, _IntlService.initializeFormatMessage)(localeData.locale, localeData.reactIntlDefaultLocale, translations);
          // fire completed callback
          callback(translations);

        case 9:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

/**
 * Sync call that awaits for response
 * @param {string[]} scripts
 * @param {LocaleData} localeData
 * @returns {Promise}
 */
var fetchLocalesPromise = exports.fetchLocalesPromise = function fetchLocalesPromise(scripts, localeData) {
  return new _promise2.default(function (resolve) {
    // callback to resolve promise
    var callback = function callback(translations) {
      resolve(translations);
    };

    (0, _scriptjs2.default)(scripts, function () {
      // dynamically register react-intl/locale-data/*<locale>.js locale data
      // https://github.com/yahoo/react-intl/wiki/Upgrade-Guide#update-how-locale-data-is-added
      // need to make sure this happens after locale scrips are loaded
      (0, _reactIntl.addLocaleData)(window.ReactIntlLocaleData[localeData.localePrefix]);

      // execute saga to fetch translations
      (0, _Store.runSaga)(fetchLocales, localeData, callback);
    });
  });
};

/**
 * Initializes localization for module
 * Downloads necessary locale files and gathers translations
 */
function initLocalization() {
  var state, localeVersion, reactIntlDefaultLocale, locale, localePrefix, moduleId, serverLocaleURL, localeData, scripts;
  return _regenerator2.default.wrap(function initLocalization$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          state = (0, _Store2.default)().getState().module;
          localeVersion = (0, _ModuleReducer.getLocaleVersion)(state);
          reactIntlDefaultLocale = (0, _ModuleReducer.getReactIntlDefaultLocale)(state);
          locale = (0, _ModuleReducer.getLocale)(state);
          localePrefix = (0, _ModuleReducer.getLocalePrefix)(state);
          moduleId = (0, _ModuleReducer.getModuleId)(state);
          serverLocaleURL = '/common/i18n/';

          /** @type {LocaleData} */

          localeData = { localeVersion: localeVersion, reactIntlDefaultLocale: reactIntlDefaultLocale, locale: locale, localePrefix: localePrefix, moduleId: moduleId, serverLocaleURL: serverLocaleURL };

          // get necessary locale data scripts

          scripts = getLocaleScripts(localeData);

          // store translation messages

          _context2.next = 11;
          return (0, _effects.call)(fetchLocalesPromise, scripts, localeData);

        case 11:
          messages = _context2.sent;

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

var getMessages = exports.getMessages = function getMessages() {
  return messages;
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/LocalizationService.js
// module id = 363
// module chunks = 10